import { MenuProvider, useMenuDispatcher, useMenuItemWithContext } from './menuContext';
import React, { useCallback } from 'react';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import Fade from 'react-reveal/Fade';
import { IComponentFieldsGeneral } from '../../../types/types';
import { HeaderModel } from '../models/header.model';
import Icon from '../../@shared/icon';
import NavigationAccordionItem from './navigationAccordionItem';
import NavigationAccordionLinkItem from './navigationAccordionLinkItem';
import { NavigationItemMenuModel } from '../models/navigationItem.model';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';
import { iconSize } from '../../../constants/icon.constants';

const MobileMenu = ({ model, fields, breakpointLg }: { model: HeaderModel; fields: IComponentFieldsGeneral; breakpointLg: boolean }) => {
  // this is a custom NavigationItemMenuStructure
  const [isOpen, setOpen] = useMenuItemWithContext();
  const handleClick = (): void => {
    setOpen(!isOpen);
  };
  const menuDispatcher = useMenuDispatcher();
  const closeMainNavigation = useCallback(() => menuDispatcher({ type: 'closeAll' }), [menuDispatcher]);
  const baseElementClassName = 'navigation__menu-item';
  const elementClassList = [baseElementClassName, baseElementClassName + '--mobile-menu'];
  if (isOpen) {
    elementClassList.push(baseElementClassName + '--open');
  }
  const elementClassName = elementClassList.join(' ');
  const icon = isOpen ? 'action-close' : 'set-nav-services-nav-menu';

  return (
    <li className={elementClassName}>
      <button className="navigation__menu-item__trigger" onClick={handleClick}>
        <span className="navigation__menu-item__trigger__content navigation__menu-item__trigger__content--with-icon">
          <Icon
            iconName={icon}
            size={icon === 'action-close' ? iconSize['mbl'] : iconSize['dsk']}
            extraClassName="navigation__menu-item__trigger__icon"
            color="primary"
          />
          <span className="navigation__menu-item__trigger__text">
            <Text field={isOpen ? model.mobileTitleOpen : model.mobileTitle} />
          </span>
        </span>
      </button>
      <div
        className={`navigation__menu-item__tray ${
          isOpen ? 'navigation__menu-item__tray--mobile-open' : 'navigation__menu-item__tray--mobile-close'
        }`}
      >
        <Fade duration={500}>
          <div className="navigation__menu-mobile-wrapper">
            <MenuProvider>
              <ul className="navigation__accordion-wrapper">
                {model.navigationItemModelsArr?.map((navigationItemModel) =>
                  navigationItemModel instanceof NavigationItemMenuModel ? (
                    <NavigationAccordionItem key={navigationItemModel?.id} model={navigationItemModel} closeMainNavigation={closeMainNavigation} />
                  ) : (
                    <NavigationAccordionLinkItem key={navigationItemModel?.id} model={navigationItemModel} closeMainNavigation={closeMainNavigation} />
                  )
                )}
              </ul>
            </MenuProvider>

            {!breakpointLg && (
              <ul className="navigation__utility">
                {/* findADealer mobile*/}
                {fields?.findDealer && (
                  <li className="navigation__utility__item" onClick={handleClick}>
                    <RoutableSitecoreLink field={fields?.findDealer?.link} className="navigation__utility__link">
                      <Icon
                        iconField={fields.findDealer?.icon}
                        extraClassName="navigation__utility__icon"
                        size={iconSize.dsk}
                        color="primary"
                      />
                      <RichText tag="div" className="navigation__utility__text rich-text" field={fields?.findDealer?.title} />
                    </RoutableSitecoreLink>
                  </li>
                )}
                {/* CountrySelector mobile*/}
                {fields?.country && (
                  <li className="navigation__utility__item">
                    <RoutableSitecoreLink field={model.countrySelector.link} className="navigation__utility__link">
                      <Icon
                        iconField={model.countrySelector?.icon}
                        extraClassName="navigation__utility__icon"
                        size={iconSize.dsk}
                        color="primary"
                      />
                      <Text tag="span" className="navigation__utility__text" field={model.countrySelector.title} />
                    </RoutableSitecoreLink>
                  </li>
                )}
                {/* search mobile*/}
                {fields?.search && (
                  <li className="navigation__utility__item" onClick={handleClick}>
                    <RoutableSitecoreLink field={fields?.search?.link} className="navigation__utility__link">
                      <Icon
                        iconField={fields.search?.icon}
                        extraClassName="navigation__utility__icon"
                        size={iconSize.dsk}
                        color="primary"
                      />
                      <span className="navigation__utility__text">{fields?.search?.link?.value?.text}</span>
                    </RoutableSitecoreLink>
                  </li>
                )}
                {/* login mobile*/}
                {fields?.login && (
                  <li className="navigation__utility__item">
                    <RoutableSitecoreLink field={fields?.login?.link} className="navigation__utility__link">
                      <Icon iconField={fields.login?.icon} extraClassName="navigation__utility__icon" size={iconSize.dsk} color="primary" />
                      <span className="navigation__utility__text">{fields?.login?.link?.value?.text}</span>
                    </RoutableSitecoreLink>
                  </li>
                )}
              </ul>
            )}
          </div>
        </Fade>
      </div>
    </li>
  );
};

export default MobileMenu;
